import { normalizeVat } from "../../../../api/hooks/config-client"
import { toFloat } from "../../../../api/hooks/lib/number"

export function operationSumEndcustomerPrice(operation: OperationOut): [OperationOut, number, number] {
    let positionCount: number = 0
    let total: number = 0

    // Calculate positions count
    let posCount = operation.positions.length

    let additionalPosCount = 0
    let vat = normalizeVat(operation.endCustomerVAT)
    if (operation.additionalPositions) {
        additionalPosCount = operation.additionalPositions.length
    }

    positionCount = posCount + additionalPosCount

    // Calculate total
    total = 0

    operation.positions.forEach((pos) => {
        if (pos.orderQuantity == 0) return
        pos.endCustomerPriceGross = pos.endCustomerPrice * (1 + vat / 100)
        total += pos.endCustomerPriceGross * pos.quantity

        // Additional Position Services
        if (pos.additionalItems) {
            pos.additionalItems.forEach((service) => {
                if (toFloat(service.netPrice)) {
                    total += toFloat(service.netPrice) * service.amount * (1 + vat / 100)
                }
            })
        }
    })

    if (operation.additionalPositions) {
        operation.additionalPositions.forEach((pos) => {
            if (toFloat(pos.netPrice)) {
                total += toFloat(pos.netPrice) * pos.amount * (1 + vat / 100)
            }
        })
    }
    operation.sumEndCustomerPrice = total / (1 + vat / 100)
    operation.sumEndCustomerPriceGross = total
    return [operation, positionCount, total]
}
